export default "__VITE_ASSET__DZ97Sc$r__"